import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;

  padding: 20px 0 0;
`;

export const Info = styled.p`
  font-size: 13px;
  color: ${colors.onSurfaceVariant};

  strong {
    color: ${colors.onSurface};
    font-weight: 600;
  }
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

interface PageButtonProps {
  active?: boolean;
}

export const PageButton = styled.button<PageButtonProps>`
  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 13px;
  font-weight: 700;

  background-color: ${({ active }) =>
    active ? colors.primary : colors.surfaceContainer};
  color: ${({ active }) =>
    active ? colors.onPrimary : colors.onSurfaceVariant};

  transition: color 0.2s, background-color 0.2s;

  &:hover:not(:disabled) {
    color: ${({ active }) => (active ? colors.onPrimary : colors.onSurface)};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
